import IService from "@api/iService";
import {UserNotification} from "@interfaces/user/users";

export default class NotificationsService extends IService {

    async fetchUserNotifications() {
        return await this.getApi<UserNotification[]>('/api/user/notification/');
    }

    async fetchUserNotification(id: string) {
        return await this.getAndThrowApi<UserNotification>(`/api/user/notification/${id}/`);
    }

    async deleteUserNotification(id: string) {
        return await this.deleteApi(`/api/user/notification/${id}`);
    }

    async readUserNotification(id: string) {
        return await this.patchApi(`/api/user/notification/${id}`, undefined);
    }

    async readAllUserNotifications() {
        return await this.patchApi('/api/user/notification/all/');
    }

}